import { easing } from "maath"
import { Canvas, useFrame, useThree } from "@react-three/fiber"
import { Sky, Bvh } from "@react-three/drei"
import { EffectComposer, Selection, Outline, N8AO, TiltShift2, ToneMapping } from "@react-three/postprocessing"
import { Scene } from "./Scene"

export const App = () => (
  <Canvas flat dpr={[1, 1.5]} gl={{ antialias: false }} camera={{ position: [0, 2, 5], fov: 30, near: 0.5, far: 30 }} shadows>
    <ambientLight intensity={1.2 * Math.PI} />
    <directionalLight position={[5, 5, 5]} intensity={0.8} castShadow shadow-mapSize={1024} />
    <Sky sunPosition={[100, 20, 100]} />
    <Bvh firstHitOnly>
      <Selection>
        <Effects />
        <Scene position={[0.5, 0, 0]} />
      </Selection>
    </Bvh>
  </Canvas>
)

function Effects() {
  const { size } = useThree()
  useFrame((state, delta) => {
    easing.damp3(state.camera.position, [state.pointer.x * 1.5, 1.8 + state.pointer.y * 0.5, 4.5 + Math.atan(state.pointer.x * 2)], 0.3, delta)
    state.camera.lookAt(state.camera.position.x * 0.5, 0.6, -2)
  })
  return (
    <EffectComposer stencilBuffer disableNormalPass autoClear={false} multisampling={4}>
      <N8AO halfRes aoSamples={5} aoRadius={0.4} distanceFalloff={0.75} intensity={1} />
      <Outline visibleEdgeColor="white" hiddenEdgeColor="white" blur width={size.width * 1.25} edgeStrength={10} />
      <TiltShift2 samples={5} blur={0.1} />
      <ToneMapping />
    </EffectComposer>
  )
}
